import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import uuid from 'uuid/v1';
import moment from 'moment';
// import axios from 'utils/axios';
import  Page from '../../components/Page';
import { Header, OrderInfo, OrderItems } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.breakpoints.values.lg,
    maxWidth: '100%',
    margin: '0 auto',
    width: '100%',
   
    padding: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(3)
  }
}));

export const OrderManagementDetails = () => {
  const classes = useStyles();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchOrder = () => {
      // axios.get('/api/orders/1').then(response => {
      //   if (mounted) {
           setOrder({
            id: uuid(),
            ref: 'FAD107',
            promoCode: null,
            value: '55.25',
            currency: '$',
            status: 'canceled',
            customer: {
              name: 'Ekaterina Tankova',
              address: 'Street King William, 42456',
              city: 'Montgomery',
              country: 'United States'
            },
            items: [
              {
                id: uuid(),
                name: 'Dr karthikeyan',
                cuantity: 0,
                billing: '38',
                status: 'Primary',
                value: '5000',
                currency: 'Rs '
              },
              {
                id: uuid(),
                name: 'Manokaran',
                cuantity: 0,
                billing: '31',
                status: 'Accompaning Person',
                value: '4000',
                currency: 'Rs '
              }
            ],
            created_at: moment()
          });
      //   }
      // });
    };

    fetchOrder();

    return () => {
      mounted = false;
    };
  }, []);

  if (!order) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Order Management Details"
    >
     <Header order={order} />
      <Grid
        className={classes.container}
        container
        spacing={3}
      >
        <Grid
          item
          md={4}
          xl={3}
          xs={12}
        >
          <OrderInfo order={order} />
        </Grid>
        <Grid
          item
          md={8}
          xl={9}
          xs={12}
        >
          <OrderItems order={order} />
        </Grid>
      </Grid> 
    </Page>
  );
};

export default OrderManagementDetails;
